interface IntlErrorLike {
    code: string;
    message: string;
    descriptor?: { id?: string; defaultMessage?: string };
}

declare global {
    interface Window {
        Sentry?: { captureMessage: (msg: string, level?: string) => void };
    }
}

const seen = new Set<string>();

export function handleMissingKey(err: IntlErrorLike): void {
    if (err.code !== 'MISSING_TRANSLATION' && err.code !== 'MISSING_DATA') {
        return;
    }

    const keyId = err.descriptor?.id ?? '<unknown>';

    if (seen.has(keyId)) return;
    seen.add(keyId);

    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error(`[i18n] missing translation: ${keyId}`);
        return;
    }

    if (window.Sentry?.captureMessage) {
        window.Sentry.captureMessage(`i18n missing: ${keyId}`, 'warning');
    }
}
